<template>
	<div class="balance_kpis_tab report_theme_container" data-theme="resultados">
		<TabHeader
			title="KPIs"
			description="Indicadores de tu balance"
			:filterPeriod="filterPeriod"
			:filterOptions="filterOptions"
			:endMonth="endMonth"
			:getNow="getNow"
			calendarMode="range"
			:dateRange="calendarRange"
			:year-range="yearRange"
			@update-filter-period="updateFilterPeriod"
			@update-end-month="updateEndMonth"
			@update-date-range="updateDateRange"
			@update-year-range="updateYearRange" />

		<!-- Grilla 2×2, mismo formato que el KPIs de Estado de Resultados. Los
			cuatro cards quedan reservados hasta definir los indicadores de
			balance (liquidez, endeudamiento, etc.). -->
		<div class="kpi_grid mt-2">
			<article v-for="n in 4" :key="n" class="kpi_card kpi_card--placeholder">
				<div class="kpi_state">Próximamente</div>
			</article>
		</div>
	</div>
</template>

<script>
import moment from "moment";
import "moment/locale/es";
import TabHeader from "@/components/financialReports/TabHeader.vue";
import { FILTER_PERIOD_OPTIONS } from "@/config/reportStructure";
import { defaultYearRange } from "@/store/financialReports/utils/dateRange";

// KPIs del Balance. Mismo formato que KpisTab (Estado de Resultados): header
// con filtros de período propios del tab + grilla 2×2 de cards. Hoy los cuatro
// indicadores están por definir → placeholders; el header ya deja los filtros
// cableados para cuando lleguen los primeros KPIs reales.
export default {
	name: "BalanceKpisTab",

	components: {
		TabHeader,
	},

	data() {
		return {
			filterOptions: FILTER_PERIOD_OPTIONS,
			// Filtro de tiempo PROPIO del tab, como en KpisTab — independiente
			// del store global `reportsFilters`.
			filterPeriod: "month",
			endMonth: moment().toDate(),
			selectedPeriodRange: "lastYear",
			customRange: null,
			customYearRange: null,
		};
	},

	computed: {
		getNow() {
			return moment().toDate();
		},

		calendarRange() {
			if (this.customRange) return this.customRange;
			const end = moment(this.endMonth).startOf("month");
			return { from: end.clone().subtract(11, "months").toDate(), to: end.toDate() };
		},

		yearRange() {
			return this.customYearRange || defaultYearRange(this.endMonth);
		},
	},

	methods: {
		updateEndMonth(date) {
			this.endMonth = date;
		},
		updateDateRange(range) {
			if (!range || !range.from || !range.to) return;
			this.customRange = range;
			this.selectedPeriodRange = "custom";
			this.endMonth = range.to;
		},
		updateYearRange(range) {
			if (!range || !range.from || !range.to) return;
			this.customYearRange = range;
		},
		updateFilterPeriod(period) {
			this.filterPeriod = period;
		},
	},
};
</script>

<style scoped lang="scss">
.balance_kpis_tab {
	position: relative;
	height: 100%;
}

// Misma grilla y cards que KpisTab.
.kpi_grid {
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-auto-rows: 340px;
	gap: 16px;
	width: 100%;

	@media (max-width: 1024px) {
		grid-template-columns: 1fr;
	}
}

.kpi_card {
	background: var(--report-bg);
	border: 1px solid var(--report-border);
	border-radius: 16px;
	box-shadow: var(--report-shadow-card);
	padding: 12px;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

.kpi_card--placeholder {
	align-items: center;
	justify-content: center;
	border-style: dashed;
}

.kpi_state {
	margin: auto;
	color: var(--report-text-muted);
	font-size: 13px;
	text-align: center;
}
</style>
